import ReactDOM from 'react-dom'

const ModalPortal = ({ children }) => {
	const el = document.getElementById('portals-modal')
	return ReactDOM.createPortal(children, el)
}

export default ModalPortal
